module.exports = __webpack_public_path__ + "static/media/3 09 Tulleord Vor er riktig.276cd002.mp3";